export { default } from './Diplomas';
